<app-list-table [logsData]="logsData$ | async" (viewClick)="viewClick($event)" (download)="onDownload()"
    (applyFilter)="_filter.next($event)"></app-list-table>